import { Grid } from "@mui/material";
import { SectionHeading } from "~/components/DetailsPage/components";
import { SoftwareVersionsChart } from "./SoftwareVersionsChart";
import { SoftwareVersionsTable } from "./SoftwareVersionsTable";
import { SoftwareVersionDistribution } from "../SoftwareVersionDistribution/SoftwareVersionDistribution";
import { SpaceOrWorkspaceScope, SpaceScope } from "~/hooks/useScope";
import { RiskFactorsIconsProps } from "~/pages/space/security/components/RiskFactors/RiskFactorsIcons";
import { UseSoftwareVersionDistributionParams } from "../SoftwareVersionDistribution/hooks/useSoftwareVersionDistribution";
import { SpaceSoftwareAggregateScoresEdges } from "../../types";

type SoftwareVersionsProps = {
  loading: boolean;
  edges: SpaceSoftwareAggregateScoresEdges;
  riskFactors: RiskFactorsIconsProps["riskFactors"];
  findingMrn: string;
  versionDistribution: UseSoftwareVersionDistributionParams["versionDistribution"];
  showVersionDistribution: boolean;
  scope: SpaceOrWorkspaceScope;
  space: SpaceScope;
};

export const SoftwareVersions = ({
  loading,
  edges,
  riskFactors,
  findingMrn,
  versionDistribution,
  showVersionDistribution,
  scope,
  space,
}: SoftwareVersionsProps) => {
  return (
    <Grid id="software-versions" size={{ xs: 12 }}>
      <SectionHeading heading="Versions" />
      {showVersionDistribution &&
        (versionDistribution?.distribution || []).length > 1 && (
          <SoftwareVersionDistribution
            versionDistribution={versionDistribution}
            findingMrn={findingMrn}
            scope={scope}
            edges={edges}
            riskFactors={riskFactors}
          />
        )}
      <SoftwareVersionsChart
        scope={scope}
        edges={edges}
        riskFactors={riskFactors}
      />
      <SoftwareVersionsTable
        scope={scope}
        space={space}
        loading={loading}
        edges={edges}
      />
    </Grid>
  );
};
